<template>
  <div>
    <h3>工厂及地址信息</h3>
    <el-table :data="dataList" size="small" stripe style="width: 100%;">
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column label="序号" header-align="center" align="center" width="50" prop="index">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="categoryDesc" label="类型描述" align="center" header-align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.categoryDesc === '配套产品生产'" style="color: red;">*</span>
          <span>{{scope.row.categoryDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fullName" label="工厂名称" align="center" header-align="center">
        <template slot-scope="scope">
          <span>{{scope.row.fullName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="shortName" label="工厂简称" align="center" header-align="center">
        <template slot-scope="scope">
          <span>{{scope.row.shortName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="地址" header-align="center" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.address}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10,15,20]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  import {getSupplieInfo3} from '@/controller/supplier'
  export default {
    data () {
      return {
        totalPage: 0,
        pageIndex:1,
        pageSize:10,
        dataForm: {
          key: ''
        },
        dataListLoading: false,
        editRowslist: [],
        dataList: [
          { categoryDesc: '配套产品研发', value: '1' },
          { categoryDesc: '配套产品生产', value: '2' },
          { categoryDesc: '配套产品销售', value: '3' },
          { categoryDesc: '配套产品委托加工', value: '4' }
        ],
      }
    },
    props: {
      superId: Number
    },
    methods: {
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      getDataList() {
        getSupplieInfo3({
          'pageNo': this.pageIndex,
          'pageSize': this.pageSize,
          'id' : this.superId
        }).then(data => {
          if (data && data.code === '00') {
            if (data.body.records.length > 0){
              this.dataList = data.body.records
              this.totalPage = data.body.total
            }
          } else {
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
    }
  }
</script>
